// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blur{
    filter: blur(10px);
    filter: brightness(50%);
}

.video-wrapper{
  height: calc(100vh - 72px);
  margin: 0 0 32px;
}

.noblur {
    filter: blur(0px);
    filter: brightness(100%);
}

.scroll-container{

    scroll-snap-type: y mandatory;
}

/* Default style for PageExtra (hidden below the screen) */
#shareModal {
  opacity: 0;
  position: fixed;
  bottom: -100%; /* Start it off-screen */
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out; /* Apply smooth animation */
  pointer-events: none;
  }
  
  /* Style when it's visible (slid up) */
  #shareModal.active {
    opacity: 1;
    bottom: 0;
    pointer-events: auto;
    
  }

  #buyNowGrid{
    display: grid;
    grid-template-columns:48px 1fr 98px;
}

  #miniSelector{
    bottom:5px;
    transition: transform 0.3s ease-in-out;
    transform: translateY(110%);
  }

  #miniSelector.buy-link-active {
    bottom:50px;
   
  }

  .slide-up-class {
    animation: slideUp 0.3s forwards;
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(110%);
    }
    to {
      transform: translateY(0%);
    }
  }
  

  #miniSelector .inner{
    display: grid;
    grid-template-columns:60px 1fr 46px;
    font-size: 0.75rem;
    line-height: 1rem;
    text-transform: uppercase;
}

  #progressBar {
    height:3px;
  
   /* @apply fixed bottom-0 left-0 transition-all duration-500;*/
  }

  #progressBarWrapper{

  }`, "",{"version":3,"sources":["webpack://./src/components/track-selector/track-selector.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,eAAe;EACf,aAAa,EAAE,wBAAwB;EACvC,OAAO;EACP,QAAQ;EACR,gCAAgC,EAAE,2BAA2B;EAC7D,oBAAoB;EACpB;;EAEA,sCAAsC;EACtC;IACE,UAAU;IACV,SAAS;IACT,oBAAoB;;EAEtB;;EAGE;IAAA,aAAW;IACX;AADW;;EAIb;IACE,UAAU;IAIV,sCAAsC;IACtC,2BAA2B;EAJ7B;;EAOA;IACE,WAAW;;EAEb;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAIE;IAAA,aAAW;IACX,mCAAmC;IACnC,kBAAwB;IAAxB,iBAAwB;IAAxB;AAFW;;EAKb;IACE,UAAU;;GAEX,6DAA6D;EAC9D;;EAEA;;EAEA","sourcesContent":[".blur{\n    filter: blur(10px);\n    filter: brightness(50%);\n}\n\n.video-wrapper{\n  height: calc(100vh - 72px);\n  margin: 0 0 32px;\n}\n\n.noblur {\n    filter: blur(0px);\n    filter: brightness(100%);\n}\n\n.scroll-container{\n\n    scroll-snap-type: y mandatory;\n}\n\n/* Default style for PageExtra (hidden below the screen) */\n#shareModal {\n  opacity: 0;\n  position: fixed;\n  bottom: -100%; /* Start it off-screen */\n  left: 0;\n  right: 0;\n  transition: all 0.3s ease-in-out; /* Apply smooth animation */\n  pointer-events: none;\n  }\n  \n  /* Style when it's visible (slid up) */\n  #shareModal.active {\n    opacity: 1;\n    bottom: 0;\n    pointer-events: auto;\n    \n  }\n\n  #buyNowGrid{\n    @apply grid;\n    grid-template-columns:48px 1fr 98px;\n  }\n\n  #miniSelector{\n    bottom:5px;\n  }\n\n  #miniSelector {\n    transition: transform 0.3s ease-in-out;\n    transform: translateY(110%);\n  }\n\n  #miniSelector.buy-link-active {\n    bottom:50px;\n   \n  }\n\n  .slide-up-class {\n    animation: slideUp 0.3s forwards;\n  }\n  \n  @keyframes slideUp {\n    from {\n      transform: translateY(110%);\n    }\n    to {\n      transform: translateY(0%);\n    }\n  }\n  \n\n  #miniSelector .inner{\n    @apply grid;\n    grid-template-columns:60px 1fr 46px;\n    @apply text-xs uppercase;\n  }\n\n  #progressBar {\n    height:3px;\n  \n   /* @apply fixed bottom-0 left-0 transition-all duration-500;*/\n  }\n\n  #progressBarWrapper{\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
